import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import catalogGraphPlugin from '@backstage/plugin-catalog-graph/alpha';
import kubernetesPlugin from '@backstage/plugin-kubernetes/alpha';
import githubActionsPlugin from '@backstage-community/plugin-github-actions/alpha';
import jenkinsPlugin from '@backstage-community/plugin-jenkins/alpha';
import { navModule } from './modules/nav';
import { authModule } from './modules/auth';
import prometheusPlugin from './modules/prometheus';
import argocdPlugin from './modules/argocd';
import headlampPlugin from './modules/headlamp';
import kubectlPlugin from './modules/kubectl';
import { catalogModule } from './modules/catalog';
import { catalogGraphModule } from './modules/catalogGraph';
import { scaffolderModule } from './modules/scaffolder';

export default createApp({
  features: [
    catalogPlugin,
    catalogModule,
    catalogGraphPlugin,
    catalogGraphModule,
    kubernetesPlugin,
    prometheusPlugin,
    argocdPlugin,
    headlampPlugin,
    kubectlPlugin,
    githubActionsPlugin,
    jenkinsPlugin,
    scaffolderModule,
    navModule,
    authModule,
  ],
});
